module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-item"
  }, [_c('div', {
    staticClass: "demo-item-container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    staticClass: "demo-item-title",
    attrs: {
      "data-title": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-description"
  }, [_c('span', {
    ref: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.descr)
    }
  }), _vm._v(" "), _c('Icon', {
    class: ['show-code-btn', {
      open: _vm.show_code
    }],
    attrs: {
      "name": "caretdown"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_code = !_vm.show_code
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('v-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_code),
      expression: "show_code"
    }],
    attrs: {
      "lang": _vm.lang,
      "code": _vm.code
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00474cac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/demo-item.vue
// module id = 614
// module chunks = 0